import { render, staticRenderFns } from "./ExtraServices.vue?vue&type=template&id=1dd6de40&"
import script from "./ExtraServices.vue?vue&type=script&lang=ts&"
export * from "./ExtraServices.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports